import React from "react";
import { TableRow, TableCell } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";

// A single placeholder <TableRow> with `columns` text-skeleton cells,
// for table-heavy list pages (Invoices, Purchases, Stock, etc.).
const TableRowSkeleton = ({ columns = 5 }) => (
  <TableRow>
    {Array.from({ length: columns }).map((_, i) => (
      <TableCell key={i}>
        <Skeleton variant="text" animation="wave" />
      </TableCell>
    ))}
  </TableRow>
);

export default TableRowSkeleton;
